import store from '@/store';
import { customerExistRepository } from '@/forms/api/repository-factory';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
import FIELD_NAMES from '@/forms/constants/field-names';
import callApi from '@/lib/helpers/call-api';
import { SET_CUSTOMER_EXIST, SET_REFERAL_CIF, CHANGE_VALUE_FIELD } from '@/lib/constants/mutations';

const parseDate = cifNumber => ({

    [FIELD_NAMES.referalCashUp]: `https://www.deem.io/cards/cash-up/?utm_source=Referral&utm_medium=${cifNumber}&utm_campaign=Cash-Up-Digital-Referral`,
    [FIELD_NAMES.referalMileUp]: `https://www.deem.io/cards/miles-up/?utm_source=Referral&utm_medium=${cifNumber}&utm_campaign=Miles-Up-Digital-Referral`,

});
const referralLinkInfo = (cifInfo) => {
    const referralLink = parseDate(cifInfo);
    Object.keys(referralLink).forEach((key) => {
        store.commit(CHANGE_VALUE_FIELD, {
            name: key,
            newValue: referralLink[key],
            newValidationStates: [],
            edited: false,
        });
    });
};
const getPayload = () => {
    const { values } = store.state.formData;
    const emirateID = getValueByFieldName(values, FIELD_NAMES.emiratesID);
    const mobileNumber = getValueByFieldName(values, FIELD_NAMES.phoneNumber);
    if (emirateID) {
        return {
            "ApiName": "customer-exists-check",
            "SearchValue": emirateID,
            "SearchType": "eid"
        };
    }
    else {

        return {
            "ApiName": "customer-exists-check",
            "SearchValue": "971" + mobileNumber,
            "SearchType": "mobile"
        };

    }
};

export default {
    async getCustomer(currentStep, callbacks) {
        const { form } = currentStep;
        let response = false;
        response = await callApi({
            callbacks,
            form,
            formElement: currentStep,
            apiCall: customerExistRepository.getCustomer,
            payload: getPayload(),
        });
        if (response) {
            referralLinkInfo(response['CIFNumber']);
            const customerExist = response['ExistingCustomer'];
            const referalCif = response['CIFNumber'];
            store.commit(SET_REFERAL_CIF, { referalCif });
            store.commit(SET_CUSTOMER_EXIST, { customerExist });
            return response;
        }
    },

};
